import { render } from "./ServicesDetailsComputerVision.vue?vue&type=template&id=2f6df518"
import script from "./ServicesDetailsComputerVision.vue?vue&type=script&lang=js"
export * from "./ServicesDetailsComputerVision.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__